module.exports = __webpack_public_path__ + "static/media/Dan2.16d583e1.png";